import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { Logo } from "@/components/Logo";
import { LangToggle, ThemeToggle } from "@/components/PrefToggles";
import { NotificationsBell } from "@/components/NotificationsBell";
import { LiveIndicator } from "@/components/LiveIndicator";
import { useAuth, homeFor } from "@/contexts/AuthContext";
import { usePrefs } from "@/contexts/PrefsContext";

export const AppHeader = ({ nav }: { nav?: ReactNode }) => {
  const { user } = useAuth();
  const { t } = usePrefs();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/75 border-b border-border/60">
      <div className="mx-auto max-w-6xl px-4 h-16 flex items-center gap-3">
        <Link to={user ? homeFor(user.role) : "/"} data-testid="header-logo-link">
          <Logo />
        </Link>
        <div className="flex-1 hidden md:flex justify-center">{nav}</div>
        <div className="ms-auto flex items-center gap-2">
          {user && <LiveIndicator />}
          {user && <NotificationsBell />}
          <LangToggle />
          <ThemeToggle />
          {user === false && (
            <Link
              to="/login"
              data-testid="header-login-button"
              className="h-10 px-4 inline-flex items-center gap-1.5 rounded-full bg-primary text-primary-foreground text-sm font-bold hover:bg-primary/90 active:scale-95 transition-[transform,background-color]"
            >
              <LogIn className="h-4 w-4 rtl:rotate-180" />
              <span className="hidden min-[400px]:inline">{t("auth.login")}</span>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
